import { Card, Row, Col } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";

export default function HelpCard({
    fullwidth = false,
}: { fullwidth?: boolean } = {}) {
    return (
        <Card className={fullwidth ? "help-card" : "help-card-thankyou"}>
            <Card.Body className="help-card-body text-center">
                <Row className="help-card-row align-items-center">
                    <Col
                        xs={12}
                        md
                        className="help-card-header-col mb-2 mb-md-0"
                    >
                        <h5 className="plan-card-header-title">Need Help?</h5>
                        <div className="plan-card-desc-bottom">
                            Our support team is here to assist you.
                            <br />
                            Reach out to us via email or WhatsApp for any
                            queries or assistance.
                        </div>
                    </Col>
                    <Col
                        xs={12}
                        md="auto"
                        className="help-card-actions-col d-flex justify-content-center gap-3 mt-2 mt-md-0"
                    >
                        <a
                            className="thankyou-app-download-link"
                            href="mailto:support@habitnu.in"
                            style={{ fontSize: 20 }}
                        >
                            <FontAwesomeIcon
                                icon={faEnvelope}
                                className="me-2"
                                size="2x"
                            />
                        </a>
                        <a
                            className="thankyou-app-download-link"
                            href="https://wa.me/918884224868"
                            style={{ fontSize: 20 }}
                        >
                            <FontAwesomeIcon
                                icon={faWhatsapp}
                                className="me-2"
                                size="2x"
                            />
                        </a>
                    </Col>
                </Row>
            </Card.Body>
        </Card>
    );
}
